var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3262 8.09788C12.3262 7.86195 12.3262 7.74402 12.3617 7.63892C12.4649 7.33347 12.7369 7.21494 13.0094 7.09082C13.3158 6.95128 13.4689 6.88151 13.6207 6.86923C13.793 6.85529 13.9656 6.89242 14.1129 6.97508C14.3081 7.08465 14.4443 7.29286 14.5837 7.46218C15.2276 8.24414 15.5494 8.63519 15.6672 9.06638C15.7623 9.4143 15.7623 9.7782 15.6672 10.1261C15.4954 10.755 14.9527 11.2822 14.5509 11.7702C14.3454 12.0198 14.2426 12.1446 14.1129 12.2174C13.9656 12.3001 13.793 12.3372 13.6207 12.3233C13.4689 12.311 13.3158 12.2412 13.0094 12.1017C12.7369 11.9775 12.4649 11.8591 12.3617 11.5536C12.3262 11.4485 12.3262 11.3305 12.3262 11.0946V8.09788Z",
    stroke: "#909090",
    strokeWidth: 0.982759
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.50147 8.09795C5.50147 7.80094 5.49313 7.53397 5.25299 7.32512C5.16564 7.24916 5.04984 7.19642 4.81825 7.09093C4.51189 6.95139 4.35871 6.88162 4.20693 6.86934C3.75155 6.83252 3.50655 7.14332 3.24394 7.46229C2.60011 8.24428 2.2782 8.63526 2.1604 9.06645C2.06535 9.41444 2.06535 9.77833 2.1604 10.1263C2.33221 10.7552 2.87499 11.2823 3.27675 11.7703C3.53001 12.0779 3.77193 12.3586 4.20693 12.3234C4.35871 12.3111 4.51189 12.2413 4.81825 12.1018C5.04984 11.9963 5.16564 11.9435 5.25299 11.8676C5.49313 11.6587 5.50147 11.3918 5.50147 11.0948V8.09795Z",
    stroke: "#909090",
    strokeWidth: 0.982759
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13647 6.86634C4.13647 4.60483 6.27535 2.77151 8.91377 2.77151C11.5522 2.77151 13.6911 4.60483 13.6911 6.86634",
    stroke: "#909090",
    strokeWidth: 0.982759,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.691 12.3261V12.8721C13.691 14.0782 12.4688 15.056 10.9611 15.056H9.59619",
    stroke: "#909090",
    strokeWidth: 0.982759,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.f0a87f8dfbd1669d67f84d4358bf54c0.svg";
export { ForwardRef as ReactComponent };